import { Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { get as _get } from 'lodash';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AnalyticsFacade } from '@amfam/shared/analytics';
import { ProfileAnalytics } from '@amfam/shared/models';
import { userQuery } from '@amfam/shared/user';
import { CopyService } from '@amfam/shared/utility/shared-services';
import { DockingBarService, PageTitleService } from '@amfam/ui-kit';

import * as fromRoot from './../../core/store';

@Component({
  selector: 'ds-update-contact',
  templateUrl: './update-contact.component.html',
  standalone: false
})
export class UpdateContactComponent implements OnInit {
  email$: Observable<string>;
  phone$: Observable<string>;
  mandateMakeChangesBtnContent: string;
  mandateLooksGoodBtnContent: string;

  constructor(
    private store: Store<fromRoot.RootState>,
    private pageTitleService: PageTitleService,
    private dockingBarService: DockingBarService,
    private copyService: CopyService,
    private analyticsFacade: AnalyticsFacade
  ) {}

  ngOnInit() {
    this.analyticsFacade.trackPage(ProfileAnalytics.updateContactInfo);
    this.pageTitleService.set('Contact Info Mandate');
    this.dockingBarService.registerHeading('Confirm Your Contact Information');
    this.email$ = this.store.pipe(
      select(userQuery.selectMyAccountEmail),
      map(email => _get(email, 'emailAddress', ''))
    );
    this.phone$ = this.store.pipe(
      select(userQuery.selectPrimaryPhone),
      map(phone => {
        if (_get(phone, 'areaCode', '') !== '' && _get(phone, 'phoneNumber', '') !== '') {
          return _get(phone, 'areaCode') + _get(phone, 'phoneNumber');
        } else {
          return 'None';
        }
      })
    );
    this.mandateMakeChangesBtnContent = this.copyService.getCopy('profile.mandateMakeChanges');
    this.mandateLooksGoodBtnContent = this.copyService.getCopy('profile.mandateLooksGood');
  }
}
